module.exports = __webpack_public_path__ + "fonts/AmplitudeTF-Italic_9919ff43.ec2a4721.woff";